import { useStorage } from "@vueuse/core";

export default {
  state: ()=>{
    return {
      showSettings: false,
      showTagsView:false,
    }
  },
  mutations: {
    changeSetting (state,obj) {
      //判断obj 是否包含 showSettings
      if(obj.showSettings !== undefined){
        state.showSettings = obj.showSettings;
      }
      if(obj.showTagsView !== undefined){
        state.showTagsView = obj.showTagsView;
      }
    },
    initSetting(state){
      // let showSettings = localStorage.getItem('showSettings');
      // if(showSettings){
      //   state.showSettings = showSettings;
      // }
    }
  },
  actions: {
    changeSetting (store,obj) {
      store.commit('changeSetting',obj)
    },
    initSetting(store){
      store.commit('initSetting')
    }
  },
  getters: {

  }
};


